const HeaderNullRender = () => {
  return <span></span>;
};

export default HeaderNullRender;
